import type { JSX } from 'react';
import { FormSection, Radio } from '@ksyos/design-system';
import type { BariPreNurseSpecialistMedScreeningReportData } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/types';
import { PatientIsMobielOpties } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/bariPreNurseSpecialistMedScreeningReportData';
import { useProcessActivityEditContext } from '@frontend/utils';
import {
    BooleanRadioGroupFormGroup,
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '../../processActivityFormGroupFields';
import { YesNoWithConditionalTextAreaFormGroup } from '../../YesNoWithConditionalTextAreaFormGroup';
export function BariPreNurseSpecialistMedScreeningReportLichamelijkOnderzoek(): JSX.Element {
    const { data } = useProcessActivityEditContext<BariPreNurseSpecialistMedScreeningReportData>();

    return (
        <FormSection title="Lichamelijk onderzoek">
            <TextAreaFormGroup
                fieldKey="abdominaal"
                label="Abdominaal"
            />
            <YesNoWithConditionalTextAreaFormGroup
                fieldKey="littekens_abdomen"
                fieldValue={data.littekens_abdomen}
                isRequired={true}
                label="Littekens abdomen"
                textAreaFieldKey="littekens_toelichting"
                textAreaLabel="Toelichting littekens"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="viscerale_obesitas"
                isClearable={true}
                label="Viscerale obesitas"
                type="radio"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="smetten"
                isClearable={true}
                label="Smetten"
                type="radio"
            />
            <RadioGroupFormGroup
                fieldKey="patient_is_mobiel"
                label="Patiënt is mobiel"
            >
                {[PatientIsMobielOpties.ja, PatientIsMobielOpties.nee, PatientIsMobielOpties.beperkt].map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
            <TextAreaFormGroup
                fieldKey="extremiteiten"
                label="Extremiteiten"
            />
        </FormSection>
    );
}
